<div *ngIf="havePermissionResource">
  <app-resource-type-configuration
    [resourceTypes]="resourceTypeService.resourceTypes$ | async"
  ></app-resource-type-configuration>

  <app-resource-configuration [resourceTypes]="resourceTypeService.resourceTypes$ | async">
  </app-resource-configuration>
</div>
